import { render, staticRenderFns } from "./billEditChargeDialog.vue?vue&type=template&id=a874a2e6&scoped=true&"
import script from "./billEditChargeDialog.vue?vue&type=script&lang=js&"
export * from "./billEditChargeDialog.vue?vue&type=script&lang=js&"
import style0 from "./billEditChargeDialog.vue?vue&type=style&index=0&id=a874a2e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a874a2e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a874a2e6')) {
      api.createRecord('a874a2e6', component.options)
    } else {
      api.reload('a874a2e6', component.options)
    }
    module.hot.accept("./billEditChargeDialog.vue?vue&type=template&id=a874a2e6&scoped=true&", function () {
      api.rerender('a874a2e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Act/billEditChargeDialog.vue"
export default component.exports